// ============================================================
// web/src/features/apprentissage/HabitudesTable.jsx — LES HABITUDES
// APPRISES DES CONSIGNES (15 septembre 2026).
// ------------------------------------------------------------
// Aucune n'est à valider : elles s'activent à 3 pièces, 70 % de respect et
// moins de 20 % de contradiction, et s'éteignent seules. L'écran les MONTRE
// — actives, et écartées avec leurs chiffres — et laisse l'administrateur
// en écarter une s'il le veut. Jamais obligé.
// ============================================================
import { useState } from 'react';
import Table from '../../ui/Table.jsx';
import Badge from '../../ui/Badge.jsx';
import Button from '../../ui/Button.jsx';
import { api } from '../../lib/api.js';
import { useSession } from '../../lib/session.jsx';
import { useToast } from '../../ui/Toast.jsx';

const MACHINE = { centre_5axes: 'centre 5 axes', centre_3axes: 'centre 3 axes', centre_4axes: 'centre 4 axes', tour_cn: 'tour CN', scie: 'scie' };
const pc = (x) => `${Math.round(Number(x ?? 0) * 100)} %`;

export function HabitudesTable({ habitudes = [], onChange }) {
  const { isAdmin } = useSession();
  const toast = useToast();
  const [envoi, setEnvoi] = useState(null);

  async function basculer(h) {
    setEnvoi(h.cle);
    try {
      await api.post(`/apprentissage/habitudes/${encodeURIComponent(h.cle)}/ecarter`, { ecartee: !h.ecartee });
      onChange?.();
    } catch (err) {
      toast.error(err.message);
    } finally {
      setEnvoi(null);
    }
  }

  const etat = (h) => {
    if (h.ecartee) return <Badge tone="neutral">écartée par vous</Badge>;
    return h.active ? <Badge tone="ok">active</Badge> : <Badge tone="neutral">en observation</Badge>;
  };

  return (
    <Table
      caption="Habitudes apprises des consignes"
      columns={[
        { key: 'etat', label: 'État', render: etat },
        { key: 'action', label: 'Habitude', render: (h) => `${h.machine_type ? `${MACHINE[h.machine_type] ?? h.machine_type} — ` : ''}${h.action}` },
        { key: 'soutien', label: 'Pièces', render: (h) => `${h.soutien} sur ${h.concernees}` },
        { key: 'respect', label: 'Respect', render: (h) => pc(h.respect) },
        { key: 'contradiction', label: 'Font autrement', render: (h) => pc(h.contradiction) },
        ...(isAdmin ? [{
          key: 'geste', label: '', render: (h) => (h.active || h.ecartee ? (
            <Button size="sm" variant="ghost" disabled={envoi === h.cle} onClick={() => basculer(h)}>
              {h.ecartee ? 'Remettre' : 'Écarter'}
            </Button>
          ) : null),
        }] : []),
      ]}
      rows={habitudes}
      getRowKey={(h) => h.cle}
    />
  );
}

export default HabitudesTable;
